import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { SystemPage } from '../site';
import { PProFetch } from '../ajax';

export default function Sidebar(props) {
	const { refreshSignal, CacheKey } = props;
	const cache = JSON.parse(window.localStorage.getItem("ecom_Sidebar_AccountMaintenanceHandler.addressJSON"));
	const cacheStamp = cache ? Date.parse(cache.stamp) : null;
	const localKey = cache ? cache.key : null;
	const [fpInfo, setFpInfo] = useState({
		root: {
			ADR1: null,
			ADR2: null,
			BALN: null,
			BLNM: null,
			CITY: null,
			CTRY: null,
			FAXN: null,
			NAME: null,
			PHON: null,
			readonly: null,
			STCD: null,
			TERMS: null,
			ZPCD: null
		},
		rowData: {}
	});

	const [loading, setLoading] = useState(true);

	const updateStateFromAjax = (json) => {
		setFpInfo({...json});
		setLoading(false);
	}

	useEffect(() => {
		setLoading(true);
		if (
			/* if manual refresh signal is incremented, refresh */
			refreshSignal > 0 ||
			(	/* or if cache is too old, refresh */
				!cacheStamp || ((new Date() - cacheStamp) > (5*60*1000))
			) || (
				/* or if cache key has changed, refresh */
				!localKey || localKey != CacheKey
			)
		) {
			PProFetch("command=AccountMaintenanceHandler.addressJSON")
			.then(response => {
				return response.json();
			})
			.then(json => {
				updateStateFromAjax(json);
				window.localStorage.setItem("ecom_Sidebar_AccountMaintenanceHandler.addressJSON", JSON.stringify({
					stamp: new Date(),
					key: CacheKey,
					data: {...json}
				}));
			});
		} else {
			updateStateFromAjax(cache.data);
		}
	}, [refreshSignal]);

	return (
		<div className="sidebar col mb-md3 mb-md-0">
			<div className="p-3 p-sm-4 shadow">
				<div className="mb-3">
					<div className="bold text-color--gray5">Account Name:</div>
					{
						loading ? <Skeleton /> :
						<div className="text-color--gray4">{fpInfo.root.NAME.value}</div>
					}
				</div>
				<div className="mb-3">
					<div className="bold text-color--gray5">Billing Address:</div>
					{
						loading ? <Skeleton count={3}/> :
						(
							<React.Fragment>
								<div className="text-color--gray4">{fpInfo.root.ADR1.value}</div>
								<div className="text-color--gray4">{fpInfo.root.ADR2.value}</div>
								<div className="text-color--gray4">{fpInfo.root.CITY.value}, {fpInfo.root.CTRY.value} {fpInfo.root.ZPCD.value}</div>
							</React.Fragment>
						)
					}
				</div>
				<div className="mb-3">
					<div className="bold text-color--gray5">Phone:</div>
					{
						loading ? <Skeleton /> :
						<div className="text-color--gray4">{fpInfo.root.PHON.value}</div>
					}
				</div>
				<div className="mb-3">
					{ props.ShowCustomerBalance === "true" ? (
					<div className="bold text-color--gray5">Account Balance:</div>
					) : null }
					{ props.ShowCustomerBalance === "true" ? (
						loading ? <Skeleton /> :
						<div className="text-color--gray4">{fpInfo.root.BALN.value}</div>
					) : null }
					{ props.ShowTerms === "true" ? (
					<div className="bold text-color--gray5">Terms:</div>
					) : null }
					{ props.ShowTerms === "true" ? (
						loading ? <Skeleton /> :
						<div className="text-color--gray4">{fpInfo.root.TERMS.value}</div>
					) : null }				
				</div>
				<hr className="my-md1" />
				<div className="row d-md-block">
					{ props.ReportsLink === "true" ? (
						<div className="col-12 col-sm-6 col-md-12 mt-3">
							<a href="command=reporthandler.options" className="button w-100 text-center">Reports</a>
						</div>
					) : null }
					{ props.ShowOrderImportLink === "true" ? (
						<div className="col-12 col-sm-6 col-md-12 mt-3">
							<a href="command=OrderImportHandler.options" className="button w-100 text-center">Order Import</a>
						</div>
					) : null }
					{ props.ShowSRPLink === "true" ? (
						<div className="col-12 col-sm-6 col-md-12 mt-3">
							<a href="command=srpcreate" className="button w-100 text-center">Update SRP</a>
						</div>
					) : null }
					{ props.ShowStandingOrderLink === "true" ? (
						<div className="col-12 col-sm-6 col-md-12 mt-3">
							<a href="command=StandingOrderHandler.options" className="button w-100 text-center">Edit Standing Orders</a>
						</div>
					) : null }
					{ props.ShowBroadcastMessageLink === "true" ? (
						<div className="col-12 col-sm-6 col-md-12 mt-3">
							<a href="command=customermessage.create" className="button w-100 text-center">Broadcast Message</a>
						</div>
					) : null }
					{ props.ShowCompanySelectionLink === "true" ? (
						<div className="col-12 col-sm-6 col-md-12 mt-3">
							<a href={props.CompanySelectionLink} className="button w-100 text-center">Change Company</a>
						</div>
					) : null }
					<div className="col-12 col-sm-6 col-md-12 mt-3">
						<a href="command=pricelist.create" className="button w-100 text-center">Pricing Request</a>
					</div>
					<div className="col-12 col-sm-6 col-md-12 mt-3">
						<a href="command=contactus.create" className="button w-100 text-center">Contact Us</a>
					</div>
					<div className="col-12 col-sm-6 col-md-12 mt-3 when-cxml-hide">
						<a href="#" onClick={() => SystemPage.doLogout()} className="button w-100 text-center">Sign Out</a>
					</div>
				</div>
			</div>
		</div>
	);
}